import { useEffect } from "react";
import { useLocation } from "wouter";
import { useSidebar } from "@/components/ui/sidebar";

/** Close the mobile drawer after navigation so content is not left covered. */
export function useCloseMobileSidebarOnNavigate() {
  const [location] = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  useEffect(() => {
    if (isMobile) setOpenMobile(false);
  }, [location, isMobile, setOpenMobile]);
}
